__turbopack_context__.v({
  "accordionSection": "cms_renderer-module-scss-module__CrccoG__accordionSection",
  "bold": "cms_renderer-module-scss-module__CrccoG__bold",
  "center": "cms_renderer-module-scss-module__CrccoG__center",
  "contentOnImageContainer": "cms_renderer-module-scss-module__CrccoG__contentOnImageContainer",
  "contentOnImageContent": "cms_renderer-module-scss-module__CrccoG__contentOnImageContent",
  "custButton": "cms_renderer-module-scss-module__CrccoG__custButton",
  "custText": "cms_renderer-module-scss-module__CrccoG__custText",
  "description": "cms_renderer-module-scss-module__CrccoG__description",
  "descriptionBoldText": "cms_renderer-module-scss-module__CrccoG__descriptionBoldText",
  "descriptionCenterText": "cms_renderer-module-scss-module__CrccoG__descriptionCenterText",
  "descriptionLargeText": "cms_renderer-module-scss-module__CrccoG__descriptionLargeText",
  "descriptionSmallText": "cms_renderer-module-scss-module__CrccoG__descriptionSmallText",
  "designer-carousel-dot-list": "cms_renderer-module-scss-module__CrccoG__designer-carousel-dot-list",
  "gridContainer": "cms_renderer-module-scss-module__CrccoG__gridContainer",
  "gridItem": "cms_renderer-module-scss-module__CrccoG__gridItem",
  "imageButtonsWithPanelPanels": "cms_renderer-module-scss-module__CrccoG__imageButtonsWithPanelPanels",
  "imageButtonsWithPanelSection": "cms_renderer-module-scss-module__CrccoG__imageButtonsWithPanelSection",
  "imageButtonsWithPanelTitle": "cms_renderer-module-scss-module__CrccoG__imageButtonsWithPanelTitle",
  "imageButtonsWithPaneldescription": "cms_renderer-module-scss-module__CrccoG__imageButtonsWithPaneldescription",
  "imageContainer": "cms_renderer-module-scss-module__CrccoG__imageContainer",
  "imgButtonCircular": "cms_renderer-module-scss-module__CrccoG__imgButtonCircular",
  "imgButtonCircular__circle": "cms_renderer-module-scss-module__CrccoG__imgButtonCircular__circle",
  "imgButtonCircular__innerCircle": "cms_renderer-module-scss-module__CrccoG__imgButtonCircular__innerCircle",
  "imgButtonCircular__outerCircle": "cms_renderer-module-scss-module__CrccoG__imgButtonCircular__outerCircle",
  "imgButtonsContainer": "cms_renderer-module-scss-module__CrccoG__imgButtonsContainer",
  "panel": "cms_renderer-module-scss-module__CrccoG__panel",
  "panelButton": "cms_renderer-module-scss-module__CrccoG__panelButton",
  "panelContainer": "cms_renderer-module-scss-module__CrccoG__panelContainer",
  "panelDescription": "cms_renderer-module-scss-module__CrccoG__panelDescription",
  "panelImage": "cms_renderer-module-scss-module__CrccoG__panelImage",
  "panelText": "cms_renderer-module-scss-module__CrccoG__panelText",
  "panelTitle": "cms_renderer-module-scss-module__CrccoG__panelTitle",
  "para": "cms_renderer-module-scss-module__CrccoG__para",
  "paraBoldText": "cms_renderer-module-scss-module__CrccoG__paraBoldText",
  "paraCenterText": "cms_renderer-module-scss-module__CrccoG__paraCenterText",
  "paraLargeText": "cms_renderer-module-scss-module__CrccoG__paraLargeText",
  "paraSmallText": "cms_renderer-module-scss-module__CrccoG__paraSmallText",
  "react-multiple-carousel__arrow": "cms_renderer-module-scss-module__CrccoG__react-multiple-carousel__arrow",
  "react-multiple-carousel__arrow--left": "cms_renderer-module-scss-module__CrccoG__react-multiple-carousel__arrow--left",
  "react-multiple-carousel__arrow--right": "cms_renderer-module-scss-module__CrccoG__react-multiple-carousel__arrow--right",
  "section": "cms_renderer-module-scss-module__CrccoG__section",
  "sectionDescription": "cms_renderer-module-scss-module__CrccoG__sectionDescription",
  "sectionDescriptionBoldText": "cms_renderer-module-scss-module__CrccoG__sectionDescriptionBoldText",
  "sectionDescriptionCenterText": "cms_renderer-module-scss-module__CrccoG__sectionDescriptionCenterText",
  "sectionDescriptionLargeText": "cms_renderer-module-scss-module__CrccoG__sectionDescriptionLargeText",
  "sectionDescriptionSmallText": "cms_renderer-module-scss-module__CrccoG__sectionDescriptionSmallText",
  "sectionTitle": "cms_renderer-module-scss-module__CrccoG__sectionTitle",
  "sliderContainer": "cms_renderer-module-scss-module__CrccoG__sliderContainer",
  "sliderDescription": "cms_renderer-module-scss-module__CrccoG__sliderDescription",
  "sliderFooter": "cms_renderer-module-scss-module__CrccoG__sliderFooter",
  "sliderHeader": "cms_renderer-module-scss-module__CrccoG__sliderHeader",
  "sliderItem": "cms_renderer-module-scss-module__CrccoG__sliderItem",
  "sliderSlider": "cms_renderer-module-scss-module__CrccoG__sliderSlider",
  "subTitle": "cms_renderer-module-scss-module__CrccoG__subTitle",
  "swapColumnItems": "cms_renderer-module-scss-module__CrccoG__swapColumnItems",
  "swapItems": "cms_renderer-module-scss-module__CrccoG__swapItems",
  "swapOrder": "cms_renderer-module-scss-module__CrccoG__swapOrder",
  "swapRowItems": "cms_renderer-module-scss-module__CrccoG__swapRowItems",
  "text": "cms_renderer-module-scss-module__CrccoG__text",
  "textBoldText": "cms_renderer-module-scss-module__CrccoG__textBoldText",
  "textCenterText": "cms_renderer-module-scss-module__CrccoG__textCenterText",
  "textLargeText": "cms_renderer-module-scss-module__CrccoG__textLargeText",
  "textSmallText": "cms_renderer-module-scss-module__CrccoG__textSmallText",
  "title": "cms_renderer-module-scss-module__CrccoG__title",
});
